import { TAX_YEAR_2021 } from '@common-packages/shared-constants';

import { defaultColumnDefinitionWithFilter } from '../shared/columnDefinitions';
import { IconCellRendererFactory } from '../shared/columnDefinitions/cellRenderers';
import {
  getCheckBoxGroupNameColumnDefinition,
  getCheckBoxGroupDescriptionColumnDefinition,
  getCheckBoxGroupValueColumnDefinition,
} from '../shared/columnDefinitions/checkBoxGroup.columnDefinition';

const getColumnDefinitions = ({
  rowData,
  getRowData,
  checkboxGroups,
  isInEditMode,
  updateGroup,
  updateRow,
  taxYear,
}) => [
  { ...getCheckBoxGroupNameColumnDefinition({ checkboxGroups }) },
  {
    ...defaultColumnDefinitionWithFilter,
    headerName: 'Page No',
    field: 'page',
    maxWidth: 60,
    cellStyle: {
      textAlign: 'center',
    },
  },
  { ...getCheckBoxGroupDescriptionColumnDefinition({ checkboxGroups }) },
  {
    ...getCheckBoxGroupValueColumnDefinition({
      ...(getRowData ? { getRowData } : { rowData }),
      isInEditMode,
      updateGroup,
      updateRow,
    }),
  },
  ...(taxYear < TAX_YEAR_2021
    ? [
        {
          ...defaultColumnDefinitionWithFilter,
          headerName: 'State Override',
          field: 'isTripletGlobal',
          width: 100,
          cellRenderer: IconCellRendererFactory({
            getName: (value, data) =>
              !data.isTripletGlobal && data.isAccountGlobal ? 'check-mark' : '',
          }),
          cellStyle: {
            textAlign: 'center',
          },
        },
        {
          ...defaultColumnDefinitionWithFilter,
          headerName: 'Is Global Account',
          field: 'isAccountGlobal',
          width: 100,
          cellRenderer: IconCellRendererFactory({
            getName: isAccountGlobal => (isAccountGlobal ? 'check-mark' : ''),
          }),
          cellStyle: {
            textAlign: 'center',
          },
        },
      ]
    : []),
];

export default getColumnDefinitions;
